//@flow
import * as Immutable from 'immutable';

import { PhoneNumber } from 'common/models/flow/PhoneNumber';
import type { PhoneNumberModelType } from 'common/models/flow/PhoneNumber';
import NumberUtils from 'common/utils/NumberUtils';

//Validation stuff
import {
    validatable,
    validate,
    validateAll,
    softValidateAll
} from 'common/utils/ValidationUtil';
import I18nHelper from 'common/helpers/I18nHelper';

const translationsNamespace = ['validations'];

const nsTranslate = I18nHelper.translate.bind(null, translationsNamespace);

@validatable
class InternalPhoneNumber extends PhoneNumber {
    static fromJS(json: PhoneNumberModelType): InternalPhoneNumber {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }

    @validate
    setPhoneNumber(phoneNumber: string): this {
        return super.setPhoneNumber(phoneNumber);
    }

    validatePhoneNumber() {
        if (this.phoneNumber && this.phoneNumber.trim().length > 16) {
            return nsTranslate('phoneNumber.lengthGreaterThan16');
        }
        if (!NumberUtils.isNumeric(this.phoneNumber)) {
            return nsTranslate('phoneNumber.invalidPhoneNumber');
        }
    }

    @validateAll
    setAllValidationErrors(): this {
        return this;
    }

    @softValidateAll
    hasValidationErrors() {}
}

export { InternalPhoneNumber as PhoneNumber };
